import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { medal } from '../../svg';
import type { PackageAward } from './entities';

@customElement('umb-package-awards')
export class UmbPackageAwards extends LitElement {
  @property({ type: Array })
  awards?: Array<PackageAward>;

  render() {
    if (!this.awards || !this.awards.length) {
      return null;
    }

    return html` <div>
      ${medal}
      <ul>
        ${this.awards.map(
          x =>
            html`<li>
              <strong>${x.result}</strong> - ${x.category}
              (${x.result === 'Hall of Fame' ? `since ${x.year}` : x.year})
            </li>`
        )}
      </ul>
    </div>`;
  }

  static styles = [
    css`
      div {
        box-sizing: border-box;
        color: #fff;
        padding: var(--s-spacer);
        font-size: 12px;
        align-self: baseline;
        display: flex;
        align-items: center;
        position: relative;
        background: var(--uui-color-default);
        border-radius: var(--xs-spacer);
        min-height: 80px;
        max-width: 360px;
      }

      svg {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 6px;
        right: 0px;
        z-index: 1;
        opacity: 0.2;
        --fill: var(--uui-color-surface);
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0;
      }

      li {
        padding-right: var(--s-spacer);
      }
    `,
  ];
}
